// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-color: #007bff;
    --secondary-color: #f8f9fa;
    --text-color: #333;
    --status-open: #007bff;
    --status-closed: #28a745;
    --status-not-delivered: #dc3545;
    --status-pending: #ffc107;
}

.dispatcher-container {
    display: flex;
    height: 100vh;
    background-color: var(--secondary-color);
    overflow: hidden; /* Убираем скроллинг */
    z-index: 100;
}

/* Боковая панель с маршрутами */
.dispatcher-sidebar {
    width: 330px;
    background: white;
    padding: 20px;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
    overflow-y: auto; /* Добавлено для возможности прокрутки */
}

.dispatcher-sidebar h2 {
    font-size: 20px;
    margin-bottom: 10px;
    text-align: center;
}

/* Контейнер для маршрутов с прокруткой */
.routes-list {
    flex-grow: 1;
    overflow-y: auto;
    padding: 0;
    margin-bottom: 10px;
}

.routes-list::-webkit-scrollbar {
    width: 6px;
}

.routes-list::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
}

.routes-list li {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
    transition: background-color 0.2s ease-in-out;
}

.routes-list li:hover,
.routes-list .active {
    background-color: var(--primary-color);
    color: white;
}

/* Основная часть с деталями маршрута */
.route-details {
    flex: 1 1;
    padding: 20px;
    overflow-y: auto;
}

.route-details h2 {
    font-size: 22px;
    margin-bottom: 10px;
}

/* Таблица квитанций */
.dispatcher-receipts-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    background: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.dispatcher-receipts-table th,
.dispatcher-receipts-table td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: center;
}

.dispatcher-receipts-table th {
    background-color: var(--primary-color);
    color: white;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
}

.dispatcher-receipts-table th:hover {
    background: #0056b3;
}

/* Статусы */
.status {
    font-weight: bold;
    padding: 5px;
    border-radius: 5px;
    color: white;
    display: inline-block;
    min-width: 100px;
}

.status.Открыта {
    background-color: var(--status-open);
}

.status.закрыта {
    background-color: var(--status-closed);
}

.status.не-доставлено {
    background-color: var(--status-not-delivered);
}

.status.в-обработке {
    background-color: var(--status-pending);
    color: black;
}

/* Заглушка, если маршрут не выбран */
.placeholder-text {
    font-size: 16px;
    color: #888;
    text-align: center;
    margin-top: 50px;
}

/* Настройки колонок */
.dispatcher-sidebar label {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 5px;
}

.dispatcher-sidebar label input {
    margin-right: 5px;
}

/* Фильтр дат */
.date-filter-row {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 10px;
}

.date-filter-row label {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333;
}

.date-filter-row input[type="date"] {
    margin-left: 5px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
}

/* Мобильная адаптация */
@media (max-width: 768px) {
    .dispatcher-container {
        flex-direction: column;
        height: auto;
    }

    .dispatcher-sidebar {
        width: 100%;
        max-height: 40vh; /* Ограничиваем высоту для удобной прокрутки */
        box-shadow: none;
        padding: 10px;
        background: #fff;
    }

    .routes-list {
        display: flex;
        flex-direction: column;
        gap: 5px;
        white-space: nowrap;
        padding: 10px 0;
        overflow-y: auto; /* Добавляем прокрутку для списка маршрутов */
    }

    .route-item.selected {
        background-color: #bbbbbb; /* светло-серый цвет */
    }

    .routes-list li {
        display: block;
        padding: 10px;
        font-size: 14px;
        border-radius: 5px;
        background: #f1f1f1;
        cursor: pointer;
    }

    .route-details {
        padding: 15px;
    }

    /* Адаптация таблицы под мобильные */
    .dispatcher-receipts-table {
        display: block;
        width: 100%;
        overflow-x: auto;
    }

    .dispatcher-receipts-table thead {
        display: none;
    }

    .dispatcher-receipts-table tbody {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .dispatcher-receipts-table tr {
        display: flex;
        flex-direction: column;
        padding: 10px;
        background: white;
        border: 1px solid #ddd;
        border-radius: 8px;
    }

    .dispatcher-receipts-table td {
        border: none;
        text-align: left;
        padding: 5px 0;
    }

    .dispatcher-receipts-table td:first-child {
        font-weight: bold;
    }
}



.modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5); /* затемнение фона */
    z-index: 1000;
  }
  
  .modal-container {
    width: 30%;
    height: 80%;
    background-color: #fff;
    border: 2px solid black; /* черная рамка */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    overflow: auto;
    position: relative;
  }
  


  .refund-button {
    background-color: #ff4d4d;
    color: white;
    padding: 10px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    margin-top: 10px;
  }
  
  .refund-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  

  /* сама ячейка селекта */
.status-select {
  width: 100%;            /* занять всю ширину ячейки */
  min-width: 120px;       /* подберите по длине самого длинного слова */
  white-space: nowrap;    /* не давать переносить текст */
  background: transparent;/* прозрачный фон, чтобы было видно цвет ячейки */
  border: none;
  color: white;           /* в свернутом виде — белый текст */
  font-weight: bold;
  cursor: pointer;
  padding: 4px 8px;
  appearance: none;       /* убрать нативную стрелку, если нужно */
  outline: none;       /* убираем стандартную обводку */
  box-shadow: none;    /* сбрасываем тень, если она есть */
}

/* опции в выпадающем списке */
.status-select option {
  color: #333;            /* чёрный текст на белом фоне */
  background: #fff;
}

/* для IE/Edge */
.status-select::-ms-expand {
  display: none;
}

.status-select:focus {
  outline: none;       /* точно убираем при фокусе */
  box-shadow: none;    /* и тень */
}



`, "",{"version":3,"sources":["webpack://./src/modules/Dispatcher/RouteDetails/RoutesDetails.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,wCAAwC;IACxC,gBAAgB,EAAE,sBAAsB;IACxC,YAAY;AAChB;;AAEA,gCAAgC;AAChC;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,yCAAyC;IACzC,gBAAgB,EAAE,wCAAwC;AAC9D;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,yCAAyC;AACzC;IACI,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,6CAA6C;AACjD;;AAEA;;IAEI,sCAAsC;IACtC,YAAY;AAChB;;AAEA,uCAAuC;AACvC;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;;IAEI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,uCAAuC;IACvC,YAAY;AAChB;;AAEA,qCAAqC;AACrC;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,gBAAgB,EAAE,8CAA8C;QAChE,gBAAgB;QAChB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;QACR,mBAAmB;QACnB,eAAe;QACf,gBAAgB,EAAE,6CAA6C;IACnE;;IAEA;QACI,yBAAyB,EAAE,sBAAsB;IACrD;;IAEA;QACI,cAAc;QACd,aAAa;QACb,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA,oCAAoC;IACpC;QACI,cAAc;QACd,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,aAAa;QACb,iBAAiB;QACjB,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;;;AAIA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC,EAAE,oBAAoB;IAC1D,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,uBAAuB,EAAE,iBAAiB;IAC1C,uCAAuC;IACvC,cAAc;IACd,kBAAkB;EACpB;;;;EAIA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;;EAGA,wBAAwB;AAC1B;EACE,WAAW,aAAa,6BAA6B;EACrD,gBAAgB,QAAQ,6CAA6C;EACrE,mBAAmB,KAAK,+BAA+B;EACvD,uBAAuB,CAAC,iDAAiD;EACzE,YAAY;EACZ,YAAY,YAAY,mCAAmC;EAC3D,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,QAAQ,wCAAwC;EAChE,aAAa,QAAQ,gCAAgC;EACrD,gBAAgB,KAAK,mCAAmC;AAC1D;;AAEA,8BAA8B;AAC9B;EACE,WAAW,aAAa,+BAA+B;EACvD,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;AACf;;AAEA;EACE,aAAa,QAAQ,6BAA6B;EAClD,gBAAgB,KAAK,WAAW;AAClC","sourcesContent":[":root {\r\n    --primary-color: #007bff;\r\n    --secondary-color: #f8f9fa;\r\n    --text-color: #333;\r\n    --status-open: #007bff;\r\n    --status-closed: #28a745;\r\n    --status-not-delivered: #dc3545;\r\n    --status-pending: #ffc107;\r\n}\r\n\r\n.dispatcher-container {\r\n    display: flex;\r\n    height: 100vh;\r\n    background-color: var(--secondary-color);\r\n    overflow: hidden; /* Убираем скроллинг */\r\n    z-index: 100;\r\n}\r\n\r\n/* Боковая панель с маршрутами */\r\n.dispatcher-sidebar {\r\n    width: 330px;\r\n    background: white;\r\n    padding: 20px;\r\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\r\n    overflow-y: auto; /* Добавлено для возможности прокрутки */\r\n}\r\n\r\n.dispatcher-sidebar h2 {\r\n    font-size: 20px;\r\n    margin-bottom: 10px;\r\n    text-align: center;\r\n}\r\n\r\n/* Контейнер для маршрутов с прокруткой */\r\n.routes-list {\r\n    flex-grow: 1;\r\n    overflow-y: auto;\r\n    padding: 0;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.routes-list::-webkit-scrollbar {\r\n    width: 6px;\r\n}\r\n\r\n.routes-list::-webkit-scrollbar-thumb {\r\n    background-color: rgba(0, 0, 0, 0.2);\r\n    border-radius: 3px;\r\n}\r\n\r\n.routes-list li {\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    border-bottom: 1px solid #ddd;\r\n    transition: background-color 0.2s ease-in-out;\r\n}\r\n\r\n.routes-list li:hover,\r\n.routes-list .active {\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n}\r\n\r\n/* Основная часть с деталями маршрута */\r\n.route-details {\r\n    flex: 1;\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.route-details h2 {\r\n    font-size: 22px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n/* Таблица квитанций */\r\n.dispatcher-receipts-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 10px;\r\n    background: white;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.dispatcher-receipts-table th,\r\n.dispatcher-receipts-table td {\r\n    border: 1px solid #ddd;\r\n    padding: 10px;\r\n    text-align: center;\r\n}\r\n\r\n.dispatcher-receipts-table th {\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    cursor: pointer;\r\n    transition: background 0.2s ease-in-out;\r\n}\r\n\r\n.dispatcher-receipts-table th:hover {\r\n    background: #0056b3;\r\n}\r\n\r\n/* Статусы */\r\n.status {\r\n    font-weight: bold;\r\n    padding: 5px;\r\n    border-radius: 5px;\r\n    color: white;\r\n    display: inline-block;\r\n    min-width: 100px;\r\n}\r\n\r\n.status.Открыта {\r\n    background-color: var(--status-open);\r\n}\r\n\r\n.status.закрыта {\r\n    background-color: var(--status-closed);\r\n}\r\n\r\n.status.не-доставлено {\r\n    background-color: var(--status-not-delivered);\r\n}\r\n\r\n.status.в-обработке {\r\n    background-color: var(--status-pending);\r\n    color: black;\r\n}\r\n\r\n/* Заглушка, если маршрут не выбран */\r\n.placeholder-text {\r\n    font-size: 16px;\r\n    color: #888;\r\n    text-align: center;\r\n    margin-top: 50px;\r\n}\r\n\r\n/* Настройки колонок */\r\n.dispatcher-sidebar label {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    padding: 5px;\r\n}\r\n\r\n.dispatcher-sidebar label input {\r\n    margin-right: 5px;\r\n}\r\n\r\n/* Фильтр дат */\r\n.date-filter-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.date-filter-row label {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    color: #333;\r\n}\r\n\r\n.date-filter-row input[type=\"date\"] {\r\n    margin-left: 5px;\r\n    padding: 5px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n}\r\n\r\n/* Мобильная адаптация */\r\n@media (max-width: 768px) {\r\n    .dispatcher-container {\r\n        flex-direction: column;\r\n        height: auto;\r\n    }\r\n\r\n    .dispatcher-sidebar {\r\n        width: 100%;\r\n        max-height: 40vh; /* Ограничиваем высоту для удобной прокрутки */\r\n        box-shadow: none;\r\n        padding: 10px;\r\n        background: #fff;\r\n    }\r\n\r\n    .routes-list {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 5px;\r\n        white-space: nowrap;\r\n        padding: 10px 0;\r\n        overflow-y: auto; /* Добавляем прокрутку для списка маршрутов */\r\n    }\r\n\r\n    .route-item.selected {\r\n        background-color: #bbbbbb; /* светло-серый цвет */\r\n    }\r\n\r\n    .routes-list li {\r\n        display: block;\r\n        padding: 10px;\r\n        font-size: 14px;\r\n        border-radius: 5px;\r\n        background: #f1f1f1;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .route-details {\r\n        padding: 15px;\r\n    }\r\n\r\n    /* Адаптация таблицы под мобильные */\r\n    .dispatcher-receipts-table {\r\n        display: block;\r\n        width: 100%;\r\n        overflow-x: auto;\r\n    }\r\n\r\n    .dispatcher-receipts-table thead {\r\n        display: none;\r\n    }\r\n\r\n    .dispatcher-receipts-table tbody {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 10px;\r\n    }\r\n\r\n    .dispatcher-receipts-table tr {\r\n        display: flex;\r\n        flex-direction: column;\r\n        padding: 10px;\r\n        background: white;\r\n        border: 1px solid #ddd;\r\n        border-radius: 8px;\r\n    }\r\n\r\n    .dispatcher-receipts-table td {\r\n        border: none;\r\n        text-align: left;\r\n        padding: 5px 0;\r\n    }\r\n\r\n    .dispatcher-receipts-table td:first-child {\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n\r\n\r\n.modal-wrapper {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.5); /* затемнение фона */\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .modal-container {\r\n    width: 30%;\r\n    height: 80%;\r\n    background-color: #fff;\r\n    border: 2px solid black; /* черная рамка */\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\r\n    overflow: auto;\r\n    position: relative;\r\n  }\r\n  \r\n\r\n\r\n  .refund-button {\r\n    background-color: #ff4d4d;\r\n    color: white;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    cursor: pointer;\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  .refund-button:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n\r\n  /* сама ячейка селекта */\r\n.status-select {\r\n  width: 100%;            /* занять всю ширину ячейки */\r\n  min-width: 120px;       /* подберите по длине самого длинного слова */\r\n  white-space: nowrap;    /* не давать переносить текст */\r\n  background: transparent;/* прозрачный фон, чтобы было видно цвет ячейки */\r\n  border: none;\r\n  color: white;           /* в свернутом виде — белый текст */\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  appearance: none;       /* убрать нативную стрелку, если нужно */\r\n  outline: none;       /* убираем стандартную обводку */\r\n  box-shadow: none;    /* сбрасываем тень, если она есть */\r\n}\r\n\r\n/* опции в выпадающем списке */\r\n.status-select option {\r\n  color: #333;            /* чёрный текст на белом фоне */\r\n  background: #fff;\r\n}\r\n\r\n/* для IE/Edge */\r\n.status-select::-ms-expand {\r\n  display: none;\r\n}\r\n\r\n.status-select:focus {\r\n  outline: none;       /* точно убираем при фокусе */\r\n  box-shadow: none;    /* и тень */\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
